import { FormTemplate } from "components/modal/templates";
import { extendedPropertyKinds, simplifiedTypeCodes, simplifiedTypeCodesEnum } from "helpers/enums";
import { formatInitial, getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import React, { Fragment } from "react";
import { applyItem } from "sources/extendedProperties";

const config = {
    id: {},
    organizationId: {},
    defaultValue: {
        label: "Значение по умолчанию",
        inputProps: { name: "defaultValue" },
    },
    displayName: {
        label: "Название",
        inputProps: { name: "displayName" },
        validators: [requiredField],
        required: true,
    },
    domainCode: {
        label: "Код домена",
        inputProps: { name: "domainCode" },
        validators: [requiredField],
        required: true,
    },
    kind: {
        label: "Объект поля",
        inputProps: { name: "kind" },
        options: extendedPropertyKinds,
        menuPortalTarget: document.body,
        unClearable: true,
        validators: [requiredField],
        required: true,
    },
    propertyName: {
        label: "Системное название",
        inputProps: { name: "propertyName" },
        validators: [requiredField],
        required: true,
    },
    typeCode: {
        label: "Тип поля",
        inputProps: { name: "typeCode" },
        options: simplifiedTypeCodes,
        menuPortalTarget: document.body,
        unClearable: true,
        validators: [requiredField],
        required: true,
    },
};

const initialState = getInitialStateFromConfig(config);

class UpdateExtendedProp extends FormTemplate {
    sendRequest = (stateData) => {
        return applyItem(stateData);
    };

    renderDeafultValue = () => {
        switch (this.state.typeCode) {
            case simplifiedTypeCodesEnum.DateTime:
            case simplifiedTypeCodesEnum.DateTimeWithoutTimezone:
                return this.renderDateField(config.defaultValue);
            case simplifiedTypeCodesEnum.Boolean:
                return this.renderCheckbox(config.defaultValue);
            default:
                return this.renderField(config.defaultValue);
        }
    };

    renderBodyInner = () => {
        return (
            <Fragment>
                {this.renderField(config.displayName)}
                {this.renderField(config.domainCode)}
                {this.renderField(config.propertyName)}
                {this.renderDeafultValue()}
                {this.renderSelect(config.kind)}
                {this.renderSelect(config.typeCode)}
            </Fragment>
        );
    };
}

const ConfiguredModal = (props) => {
    const initialData = formatInitial(props.data, initialState, "edit");
    return <UpdateExtendedProp {...props} config={config} initialState={initialData} />;
};

export default ConfiguredModal;
